import { Nav, NavItem, Navbar } from 'react-bootstrap'
import { VIEW_DATASET_MEASUREMENT, VIEW_DATASET_PLATESETUP, VIEW_DATASET_SUMMARY } from '../../../constants/saxs'

import PropTypes from 'prop-types'
import React from 'react'

/**
 * React compnent used to render a google like menu. It is based on navbar from boostrap so responsive.
 */
class DataCollectionListMenu extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activeTab: 1,
    }

    this.onTabClicked = this.onTabClicked.bind(this)
  }

  render() {
    return (
      <Navbar className="navbarCustom">
        <Navbar.Header>
          <Navbar.Toggle />
        </Navbar.Header>
        <Navbar.Collapse>
          <Nav activeKey={this.state.activeTab} onSelect={this.onTabClicked}>
            <NavItem eventKey={1} href="#" onClick={() => this.props.setView(VIEW_DATASET_SUMMARY)}>
              <span> Summary </span>
            </NavItem>
            <NavItem eventKey={2} href="#" onClick={() => this.props.setView(VIEW_DATASET_MEASUREMENT)}>
              <span> Measurements </span>
            </NavItem>
            <NavItem eventKey={3} href="#" onClick={() => this.props.setView(VIEW_DATASET_PLATESETUP)}>
              <span> Sample plate setup </span>
            </NavItem>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
    )
  }

  onTabClicked(selectedKey) {
    this.setState({ activeTab: selectedKey })
  }
}

DataCollectionListMenu.propTypes = {
  /** Callback triggered when the user clicks on summary in the dataset menu */
  onDatasetSummaryMenuClicked: PropTypes.func,
  /** Callback triggered when the user clicks on measurements in the dataset menu */
  onDatasetMeasurementMenuClicked: PropTypes.func,
  /** Callback triggered when the user clicks on sample plate setup in the dataset menu */
  onDatasetPlateSetupMenuClicked: PropTypes.func,
}

export default DataCollectionListMenu
